import { Avatar } from '@amelio/ui-library';

import type { User } from '@/types/directory/User';

import { getInitials, getProfilePictureUrl } from '@/utils/user';

interface EmployeeAvatarProps {
    employeeName: string;
    employeeAvatarUrl?: string;
    employeeUser?: User;
}

export const EmployeeAvatar = ({
    employeeName,
    employeeAvatarUrl,
    employeeUser,
}: EmployeeAvatarProps) => {
    const initials = employeeUser
        ? getInitials(employeeUser)
        : employeeName.substring(0, 2).toUpperCase();

    // No third fallback: this used to end on `employeeProfile`, which carries the employee's *job
    // profile* everywhere else, and which this page fed with a raw stored path. It stayed harmless
    // only while `getProfilePictureUrl` always returned an address; the moment it can return
    // nothing, that path reaches `src` unresolved and the browser shows a broken image instead of
    // the initials.
    const resolvedAvatarUrl =
        employeeAvatarUrl || getProfilePictureUrl(employeeUser?.profilePictureUrl || '');

    return (
        <div className={'relative flex-shrink-0'}>
            <div
                className={
                    'from-primary absolute inset-0 rounded-full bg-gradient-to-br to-purple-500 opacity-40 blur-lg'
                }
            />
            <Avatar
                size={'md'}
                src={resolvedAvatarUrl}
                bgColor={'default'}
                alt={employeeName}
                initials={initials}
                className={
                    'relative !h-[64px] !w-[64px] border-[3px] border-white shadow-lg sm:!h-[90px] sm:!w-[90px]'
                }
            />
        </div>
    );
};

EmployeeAvatar.displayName = 'EmployeeAvatar';
